import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {PpoNetworkStore, ppoNetworkTypeEnum} from './types';

export const usePpoNetworkStore = create<PpoNetworkStore>()(
	persist(
		set => ({
			ppoNetworkType: ppoNetworkTypeEnum.ALL,
			setPpoNetworkType: value => set({ppoNetworkType: value}),
			resetPpoNetworkType: () => set({ppoNetworkType: undefined}),
		}),
		{
			name: '@hapvida/ppo-network-store',
		},
	),
);
